
<div class="dhl-component-container-v2">
    <div class="title-container-v2">
       <!-- get the value from template -->
      <label *ngIf="configData.label" class="title-main-label">{{configData.label}}: {{frmGroup.get(configData.name).businessObjectId}}</label>
      <!-- <span class="main-label-value">{{ orderId }}</span> -->
    </div>
    <div class="component-content-container">
      <app-form-field *ngFor="let control of configData.controls;let ctrlIndex=index" [configData]="control"
                [ngClass]="getColsClass(control.cols)" [frmGroup]="createForm(ctrlIndex)">
      </app-form-field>
    <!--  <app-form (form)="getForm($event)"   [configData]=configData></app-form>    -->   
    </div>

    <!-- <div [formGroup]="frmGroup">
      <div >
        <div *ngFor="let form of createForm();let i = index">
          <div class="component-content-container" *ngFor="let control of configData.controls">
            <app-form-field [configData]="control"
                [frmGroup]="createForm()[i]" [ngClass]="getColsClass(control.cols)">
            </app-form-field> 
          </div>        
        </div>      
      </div>    
    </div>     -->

    <!-- <div class="row" *ngFor="let row of createForm(); let rowIndex = index">
      <app-form-field id="{{configData.name}}" *ngFor="let control of configData.controls" [configData]="control"
        [frmGroup]="createForm()[rowIndex]" [ngClass]="getColsClass(control)">
      </app-form-field>  
    </div>    -->

    </div>